<template>
  <div class="l-container">
    <!-- <div>{{obj}}</div> -->

    <p class="m-label">アップロード対象選択
      <i class="fa fa-sort-alpha-desc"></i>ソート<i class="fa fa-fw fa-angle-down"></i>
      <span>
        <template v-if="this.sortColumn2 === 'id'">ID</template>
        <template v-if="this.sortColumn2 === 'family_tel1'">生徒TEL</template>
        <template v-if="this.sortColumn2 === 'student_name'">生徒</template>
        <template v-if="this.sortColumn2 === 'student_kana'">せいと</template>
        <template v-if="this.sortColumn2 === 'tutor_tel1'">先生TEL</template>
        <template v-if="this.sortColumn2 === 'tutor_name'">先生</template>
        <template v-if="this.sortColumn2 === 'tutor_kana'">せんせい</template>
         : {{sortState2}}
      </span>
    </p>
    <div class="index-box ReportsIndex" @scroll="offset">
      <table-c>
        <tr-c slot="tr-th">
          <td-c><input v-model="search2.id" type="text" @keyup="searchTable2()" placeholder="検索"></td-c>
          <td-c><input v-model="search2.family_tel1" type="text" @keyup="searchTable2()"></td-c>
          <td-c><input v-model="search2.student_name" type="text" @keyup="searchTable2()"></td-c>
          <td-c><input v-model="search2.student_kana" type="text" @keyup="searchTable2()"></td-c>
          <td-c><input v-model="search2.tutor_tel1" type="text" @keyup="searchTable2()"></td-c>
          <td-c><input v-model="search2.tutor_name" type="text" @keyup="searchTable2()"></td-c>
          <td-c><input v-model="search2.tutor_kana" type="text" @keyup="searchTable2()"></td-c>
        </tr-c>

        <tr-c slot="tr-th">
          <td-c><input v-model="search2.not_id" type="text" @keyup="searchTable2()" placeholder="除外"></td-c>
          <td-c><input v-model="search2.not_family_tel1" type="text" @keyup="searchTable2()"></td-c>
          <td-c><input v-model="search2.not_student_name" type="text" @keyup="searchTable2()"></td-c>
          <td-c><input v-model="search2.not_student_kana" type="text" @keyup="searchTable2()"></td-c>
          <td-c><input v-model="search2.not_tutor_tel1" type="text" @keyup="searchTable2()"></td-c>
          <td-c><input v-model="search2.not_tutor_name" type="text" @keyup="searchTable2()"></td-c>
          <td-c><input v-model="search2.not_tutor_kana" type="text" @keyup="searchTable2()"></td-c>
        </tr-c>

        <tr-c slot="tr-th">
          <th-c @click.native='sort2("id")'>ID</th-c>
          <th-c @click.native='sort2("family_tel1")'>生徒TEL</th-c>
          <th-c @click.native='sort2("student_name")'>生徒</th-c>
          <th-c @click.native='sort2("student_kana")'>せいと</th-c>
          <th-c @click.native='sort2("tutor_tel1")'>先生TEL</th-c>
          <th-c @click.native='sort2("tutor_name")'>先生</th-c>
          <th-c @click.native='sort2("tutor_kana")'>せんせい</th-c>
        </tr-c>

        <tr-c slot="tr-td" @click.native="getId(student_tutor)" v-for="(student_tutor, index) in orderedStudent_tutors" :key="student_tutor.id">
          <template v-if="report.student_tutor_id === student_tutor.id">
            <td-c class="clicked">{{student_tutor.id}}</td-c>
            <td-c class="clicked">{{student_tutor.student.family.tel1}}</td-c>
            <td-c class="clicked">{{student_tutor.student.f_name}} {{student_tutor.student.l_name}}</td-c>
            <td-c class="clicked">{{student_tutor.student.f_name_kana}} {{student_tutor.student.l_name_kana}}</td-c>
            <template v-if="student_tutor.tutor">
              <td-c class="clicked">{{student_tutor.tutor.tel1}}</td-c>
              <td-c class="clicked">{{student_tutor.tutor.f_name}} {{student_tutor.tutor.l_name}}</td-c>
              <td-c class="clicked">{{student_tutor.tutor.f_name_kana}} {{student_tutor.tutor.l_name_kana}}</td-c>
            </template>
            <template v-else>
              <td-c></td-c>
              <td-c></td-c>
              <td-c></td-c>
            </template>
          </template>

          <template v-if="report.student_tutor_id !== student_tutor.id">
            <td-c>{{student_tutor.id}}</td-c>
            <td-c>{{student_tutor.student.family.tel1}}</td-c>
            <td-c>{{student_tutor.student.f_name}} {{student_tutor.student.l_name}}</td-c>
            <td-c>{{student_tutor.student.f_name_kana}} {{student_tutor.student.l_name_kana}}</td-c>
            <template v-if="student_tutor.tutor">
              <td-c>{{student_tutor.tutor.tel1}}</td-c>
              <td-c>{{student_tutor.tutor.f_name}} {{student_tutor.tutor.l_name}}</td-c>
              <td-c>{{student_tutor.tutor.f_name_kana}} {{student_tutor.tutor.l_name_kana}}</td-c>
            </template>
            <template v-else>
              <td-c></td-c>
              <td-c></td-c>
              <td-c></td-c>
            </template>
          </template>
        </tr-c>
      </table-c>
    </div>


    <h1 class="m-label m-label-custom" @click="switchV('column')" v-bind:class="{ 'slideActive': column }" v-ripple>項目
      <i class="fa fa-sort-alpha-desc"></i>ソート<i class="fa fa-fw fa-angle-down"></i>
      <span>
        <template v-if="this.sortColumn === 'id'">ID</template>
        <template v-if="this.sortColumn === 'student_tutor_id'">student_tutor_id</template>
        <template v-if="this.sortColumn === 'student_name'">生徒</template>
        <template v-if="this.sortColumn === 'student_kana'">せいと</template>
        <template v-if="this.sortColumn === 'tutor_name'">先生</template>
        <template v-if="this.sortColumn === 'tutor_kana'">せんせい</template>
        <template v-if="this.sortColumn === 'month'">何月分</template>
        <template v-if="this.sortColumn === 'state'">現状</template>
        <template v-if="this.sortColumn === 'note'">備考</template>
        <template v-if="this.sortColumn === 'file_name'">ファイル名</template>
        <template v-if="this.sortColumn === 'points_english'">英語</template>
        <template v-if="this.sortColumn === 'points_mathematics'">数学</template>
        <template v-if="this.sortColumn === 'points_japanese'">国語</template>
        <template v-if="this.sortColumn === 'points_science'">理科</template>
        <template v-if="this.sortColumn === 'points_socialstudies'">社会</template>
        <template v-if="this.sortColumn === 'file'">ファイル</template>
        <template v-if="this.sortColumn === 'user'">登録者</template>
        <template v-if="this.sortColumn === 'created_at'">作成日</template>
         : {{sortState}}
      </span>
    </h1>
    <template v-if="column">
      <div style="display: flex; flex-wrap: wrap">
        <btn class="m-btn--column" @click.native="reset()">RESET</btn>
        <btn class="m-btn--column" @click.native="all()">ALL</btn>
        <btn class="m-btn--column" @click.native="switchV('id')" v-bind:class="{ 'active': id }">ID</btn>
        <btn class="m-btn--column" @click.native="switchV('student_tutor_id')" v-bind:class="{ 'active': student_id }">student_tutor_id</btn>
        <btn class="m-btn--column" @click.native="switchV('student_name')" v-bind:class="{ 'active': student_name }">生徒</btn>
        <btn class="m-btn--column" @click.native="switchV('student_kana')" v-bind:class="{ 'active': student_kana }">せいと</btn>
        <btn class="m-btn--column" @click.native="switchV('tutor_name')" v-bind:class="{ 'active': tutor_name }">先生</btn>
        <btn class="m-btn--column" @click.native="switchV('tutor_kana')" v-bind:class="{ 'active': tutor_kana }">せんせい</btn>
        <btn class="m-btn--column" @click.native="switchV('month')" v-bind:class="{ 'active': month }">何月分</btn>
        <btn class="m-btn--column" @click.native="switchV('state')" v-bind:class="{ 'active': state }">現状</btn>
        <btn class="m-btn--column" @click.native="switchV('note')" v-bind:class="{ 'active': note }">備考</btn>
        <btn class="m-btn--column" @click.native="switchV('file_name')" v-bind:class="{ 'active': file_name }">ファイル名</btn>
        <btn class="m-btn--column" @click.native="switchV('points_english')" v-bind:class="{ 'active': points_english }">英語</btn>
        <btn class="m-btn--column" @click.native="switchV('points_mathematics')" v-bind:class="{ 'active': points_mathematics }">数学</btn>
        <btn class="m-btn--column" @click.native="switchV('points_japanese')" v-bind:class="{ 'active': points_japanese }">国語</btn>
        <btn class="m-btn--column" @click.native="switchV('points_science')" v-bind:class="{ 'active': points_science }">理科</btn>
        <btn class="m-btn--column" @click.native="switchV('points_socialstudies')" v-bind:class="{ 'active': points_socialstudies }">社会</btn>
        <btn class="m-btn--column" @click.native="switchV('file')" v-bind:class="{ 'active': file }">ファイル</btn>
        <btn class="m-btn--column" @click.native="switchV('user')" v-bind:class="{ 'active': user }">登録者</btn>
        <btn class="m-btn--column" @click.native="switchV('created_at')" v-bind:class="{ 'active': created_at }">作成日</btn>
      </div>
    </template>

    <div style="display: flex" class="ReportsIndex_upload">
      <form class="upload_form" method="post" enctype="multipart/form-data" @submit.prevent="postReport" @keypress.stop.prevent.13>
        <div class="container">
          <input type="text" required class="input" v-model="report.student_tutor_id" placeholder="student_tutor_id">
          <input type="text" required maxlength="7" minlength="7" class="input" v-model="report.month" placeholder="0001/01">
          <multiselect v-model="watch.state" :options="State" label="name" :show-labels="false" placeholder="現状"></multiselect>
          <multiselect v-model="watch.file_name" :options="fileName" label="name" :show-labels="false" placeholder="ファイル名"></multiselect>
          <div class="box">
            <i class="fa fa-camera"></i>
            <input @change="selectedFile" type="file" id="file">
          </div>
          <btn type="submit" class="upload">アップロード</btn>
        </div>

        <div class="container">
          <textarea class="note" v-model="report.note" type="text" placeholder="備考"></textarea>
          <input type="text" class="points" v-model="report.points_english" placeholder="英語">
          <input type="text" class="points" v-model="report.points_mathematics" placeholder="数学">
          <input type="text" class="points" v-model="report.points_japanese" placeholder="国語">
          <input type="text" class="points" v-model="report.points_science" placeholder="理科">
          <input type="text" class="points" v-model="report.points_socialstudies" placeholder="社会">
        </div>
      </form>
    </div>

    <div class="index-box2 ReportsIndex" @scroll="offset">
      <table-c>

        <tr-c slot="tr-th">
          <td-c></td-c>
          <td-c style="text-align: center">検索</td-c>
          <template v-if="id"><td-c><input v-model="search.id" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="student_tutor_id"><td-c><input v-model="search.student_tutor_id" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="student_name"><td-c><input v-model="search.student_name" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="student_kana"><td-c><input v-model="search.student_kana" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="tutor_name"><td-c><input v-model="search.tutor_name" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="tutor_kana"><td-c><input v-model="search.tutor_kana" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="month"><td-c><input v-model="search.month" type="text" @keyup="searchTable()" placeholder="0001/01"></td-c></template>
          <template v-if="state">
            <td-c class="select">
              <multiselect @select="select, searchTable()" v-model="watchSearch.state" :options="State" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="note"><td-c><input v-model="search.note" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="file_name">
            <td-c class="select">
              <multiselect @select="select, searchTable()" v-model="watchSearch.file_name" :options="fileName" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="points_english"><td-c><input v-model="search.points_english" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="points_mathematics"><td-c><input v-model="search.points_mathematics" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="points_japanese"><td-c><input v-model="search.points_japanese" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="points_science"><td-c><input v-model="search.points_science" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="points_socialstudies"><td-c><input v-model="search.points_socialstudies" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="file"><td-c></td-c></template>
          <template v-if="user"><td-c><input v-model="search.user" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="created_at"><td-c><input v-model="search.created_at" type="text" @keyup="searchTable()"></td-c></template>
        </tr-c>

        <tr-c slot="tr-th">
          <td-c></td-c>
          <td-c style="text-align: center">除外</td-c>
          <template v-if="id"><td-c><input v-model="search.not_id" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="student_tutor_id"><td-c><input v-model="search.not_student_tutor_id" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="student_name"><td-c><input v-model="search.not_student_name" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="student_kana"><td-c><input v-model="search.not_student_kana" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="tutor_name"><td-c><input v-model="search.not_tutor_name" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="tutor_kana"><td-c><input v-model="search.not_tutor_kana" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="month"><td-c><input v-model="search.not_month" type="text" @keyup="searchTable()" placeholder="0001/01"></td-c></template>
          <template v-if="state">
            <td-c class="select">
              <multiselect @select="select, searchTable()" v-model="watchSearch.not_state" :options="State" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="note"><td-c><input v-model="search.not_note" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="file_name">
            <td-c class="select">
              <multiselect @select="select, searchTable()" v-model="watchSearch.not_file_name" :options="fileName" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="points_english"><td-c><input v-model="search.not_points_english" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="points_mathematics"><td-c><input v-model="search.not_points_mathematics" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="points_japanese"><td-c><input v-model="search.not_points_japanese" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="points_science"><td-c><input v-model="search.not_points_science" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="points_socialstudies"><td-c><input v-model="search.not_points_socialstudies" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="file"><td-c></td-c></template>
          <template v-if="user"><td-c><input v-model="search.not_user" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="created_at"><td-c><input v-model="search.not_created_at" type="text" @keyup="searchTable()"></td-c></template>
        </tr-c>

        <tr-c slot="tr-th">
          <th-c style="text-align: center">削除</th-c>
          <th-c style="text-align: center">編集</th-c>
          <template v-if="id"><th-c @click.native='sort("id")'>ID</th-c></template>
          <template v-if="student_tutor_id"><th-c @click.native='sort("student_tutor_id")'>student_tutor_id</th-c></template>
          <template v-if="student_name"><th-c @click.native='sort("student_name")'>生徒</th-c></template>
          <template v-if="student_kana"><th-c @click.native='sort("student_kana")'>せいと</th-c></template>
          <template v-if="tutor_name"><th-c @click.native='sort("tutor_name")'>先生</th-c></template>
          <template v-if="tutor_kana"><th-c @click.native='sort("tutor_kana")'>せんせい</th-c></template>
          <template v-if="month"><th-c @click.native='sort("month")'>何月分</th-c></template>
          <template v-if="state"><th-c @click.native='sort("state")'>現状</th-c></template>
          <template v-if="note"><th-c @click.native='sort("note")'>備考</th-c></template>
          <template v-if="file_name"><th-c @click.native='sort("file_name")'>ファイル名</th-c></template>
          <template v-if="points_english"><th-c @click.native='sort("points_english")'>英語</th-c></template>
          <template v-if="points_mathematics"><th-c @click.native='sort("points_mathematics")'>数学</th-c></template>
          <template v-if="points_japanese"><th-c @click.native='sort("points_japanese")'>国語</th-c></template>
          <template v-if="points_science"><th-c @click.native='sort("points_science")'>理科</th-c></template>
          <template v-if="points_socialstudies"><th-c @click.native='sort("points_socialstudies")'>社会</th-c></template>
          <template v-if="file"><th-c @click.native='sort("file")'>ファイル</th-c></template>
          <template v-if="user"><th-c @click.native='sort("user")'>User</th-c></template>
          <template v-if="created_at"><th-c @click.native='sort("created_at")'>作成日</th-c></template>
        </tr-c>

        <tr-c slot="tr-td" v-for="(list, index) in orderedReports" :key="index.id" class="tr_hover ReportsIndex_upload" v-bind:class="{ 'list-edit': list.id == edit_id.edit_id }">

          <template v-if="list.id == edit_id.edit_id">

            <td-c @click.native="cancelReport(list)" class="del">戻る</td-c>
            <td-c @click.native="patchReport(list)" class="del">更新</td-c>
            <template v-if="id"><td-c>{{list.id}}</td-c></template>
            <template v-if="student_tutor_id"><td-c>{{list.student_tutor_id}}</td-c></template>
            <template v-if="student_name"><td-c>{{list.student_tutor.student.f_name}} {{list.student_tutor.student.l_name}}</td-c></template>
            <template v-if="student_kana"><td-c>{{list.student_tutor.student.f_name_kana}} {{list.student_tutor.student.l_name_kana}}</td-c></template>
            <template v-if="list.tutor">
              <template v-if="tutor_name"><td-c>{{list.student_tutor.tutor.f_name}} {{list.student_tutor.tutor.l_name}}</td-c></template>
              <template v-if="tutor_kana"><td-c>{{list.student_tutor.tutor.f_name_kana}} {{list.student_tutor.tutor.l_name_kana}}</td-c></template>
            </template>
            <template v-else>
              <td-c></td-c>
              <td-c></td-c>
            </template>
            <template v-if="month"><td-c><input type="text" v-model="list.month"></td-c></template>
            <template v-if="state">
              <td-c class="select">
                <multiselect v-model="watchPatch.state" :options="State" label="name" :show-labels="false" placeholder="現状"></multiselect>
              </td-c>
            </template>
            <template v-if="note"><td-c><textarea type="text" v-model="list.note"></textarea></td-c></template>
            <template v-if="file_name">
              <td-c class="select">
                <multiselect v-model="watchPatch.file_name" :options="fileName" label="name" :show-labels="false" placeholder="ファイル名"></multiselect>
              </td-c>
            </template>
            <template v-if="points_english"><td-c><input type="text" v-model="list.points_english"></td-c></template>
            <template v-if="points_mathematics"><td-c><input type="text" v-model="list.points_mathematics"></td-c></template>
            <template v-if="points_japanese"><td-c><input type="text" v-model="list.points_japanese"></td-c></template>
            <template v-if="points_science"><td-c><input type="text" v-model="list.points_science"></td-c></template>
            <template v-if="points_socialstudies"><td-c><input type="text" v-model="list.points_socialstudies"></td-c></template>
            <template v-if="file">
              <td-c>
                <form class="update_form" enctype="multipart/form-data">
                  <input @change="patchSelectedFile" type="file" id="file">
                </form>
              </td-c>
            </template>
            <template v-if="user"><td-c>{{list.user.user}}</td-c></template>
            <template v-if="created_at"><td-c>{{list.created_at.substring(0, 10)}}</td-c></template>

          </template>

          <template v-if="list.id !== edit_id.edit_id">
            <td-c @click.native="deleteReport(list)" class="del">削除</td-c>
            <td-c @click.native="edit(list)" class="del">編集</td-c>
            <template v-if="id"><a v-bind:href="linkReport(list)" target="_blank" class="link">{{list.id}}</a></template>
            <template v-if="student_tutor_id"><a v-bind:href="linkReport(list)" target="_blank" class="link">{{list.student_tutor_id}}</a></template>
            <template v-if="student_name"><a v-bind:href="linkReport(list)" target="_blank" class="link">{{list.student_tutor.student.f_name}} {{list.student_tutor.student.l_name}}</a></template>
            <template v-if="student_kana"><a v-bind:href="linkReport(list)" target="_blank" class="link">{{list.student_tutor.student.f_name_kana}} {{list.student_tutor.student.l_name_kana}}</a></template>
            <template v-if="list.tutor">
              <template v-if="tutor_name"><a v-bind:href="linkReport(list)" target="_blank" class="link">{{list.student_tutor.tutor.f_name}} {{list.student_tutor.tutor.l_name}}</a></template>
              <template v-if="tutor_kana"><a v-bind:href="linkReport(list)" target="_blank" class="link">{{list.student_tutor.tutor.f_name_kana}} {{list.student_tutor.tutor.l_name_kana}}</a></template>
            </template>
            <template v-else>
              <td-c></td-c>
              <td-c></td-c>
            </template>
            <template v-if="month"><a v-bind:href="linkReport(list)" target="_blank" class="link">{{list.month}}</a></template>
            <template v-if="state">
              <a v-bind:href="linkReport(list)" target="_blank" class="link" v-if="list.state === 0">未選択</a>
              <a v-bind:href="linkReport(list)" target="_blank" class="link" v-if="list.state === 1">提出済</a>
              <a v-bind:href="linkReport(list)" target="_blank" class="link" v-if="list.state === 2">連絡済</a>
              <a v-bind:href="linkReport(list)" target="_blank" class="link" v-if="list.state === 3">未提出</a>
              <a v-bind:href="linkReport(list)" target="_blank" class="link" v-if="list.state === 4">テキスト未使用</a>
            </template>
            <template v-if="note"><a v-bind:href="linkReport(list)" target="_blank" class="link">{{list.note}}</a></template>
            <template v-if="file_name">
              <a v-bind:href="linkReport(list)" target="_blank" class="link" v-if="list.file_name === 0">未選択</a>
              <a v-bind:href="linkReport(list)" target="_blank" class="link" v-if="list.file_name === 1">指導報告書</a>
              <a v-bind:href="linkReport(list)" target="_blank" class="link" v-if="list.file_name === 2">引継文章</a>
            </template>
            <template v-if="points_english"><a v-bind:href="linkReport(list)" target="_blank" class="link">{{list.points_english}}</a></template>
            <template v-if="points_mathematics"><a v-bind:href="linkReport(list)" target="_blank" class="link">{{list.points_mathematics}}</a></template>
            <template v-if="points_japanese"><a v-bind:href="linkReport(list)" target="_blank" class="link">{{list.points_japanese}}</a></template>
            <template v-if="points_science"><a v-bind:href="linkReport(list)" target="_blank" class="link">{{list.points_science}}</a></template>
            <template v-if="points_socialstudies"><a v-bind:href="linkReport(list)" target="_blank" class="link">{{list.points_socialstudies}}</a></template>
            <template v-if="file"><a v-bind:href="linkReport(list)" target="_blank" class="link"></a></template>
            <template v-if="user"><a v-bind:href="linkReport(list)" target="_blank" class="link">{{list.user.user}}</a></template>
            <template v-if="created_at"><a v-bind:href="linkReport(list)" target="_blank" class="link">{{list.created_at.substring(0, 10)}}</a></template>
          </template>

        </tr-c>
      </table-c>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { getAPIURL } from '@/store/getters.js'
import config from '@/settings/config.js'
const url = getAPIURL() + '/api/v1/reports/search?limit=' + config.LIMIT
const url2 = getAPIURL() + '/api/v1/student_tutors/search?limit=' + config.LIMIT

// var TIMER = null
var obj = {
  timer: null,
  TIMER: null,
  COUNT: 1,
  offset: config.LIMIT,
  max: config.LIMIT + 1,
  url: url,
  searchUrl: url,
  pageName: 'report',
  pageNames: 'reports'
}

var obj2 = {
  timer: null,
  TIMER: null,
  COUNT: 1,
  offset: config.LIMIT,
  max: config.LIMIT + 1,
  url: url2,
  searchUrl: url2,
  pageName: 'student_tutor',
  pageNames: 'student_tutors'
}

let _ = window._
export default {
  computed: {
    obj () {
      return obj
    },

    reports () {
      return this.$store.getters.reports
    },

    // order By
    orderedReportsDefault () {
      return _.orderBy(this.reports, this.created_at).reverse()
    },

    // order By
    orderedReports () {
      if (this.sortState === '' || this.sortState === '降順') {
        return _.orderBy(this.orderedReportsDefault, this.sortColumn).reverse()
      } else if (this.sortState === '昇順') {
        return _.orderBy(this.orderedReportsDefault, this.sortColumn)
      }
    },

    student_tutors () {
      return this.$store.getters.student_tutors
    },

    // order By
    orderedStudent_tutors () {
      if (this.sortState2 === '' || this.sortState2 === '降順') {
        return _.orderBy(this.student_tutors, this.sortColumn2).reverse()
      } else if (this.sortState2 === '昇順') {
        return _.orderBy(this.student_tutors, this.sortColumn2)
      }
    }
  },
  data () {
    return {
      edit_id: {
        edit_id: ''
      },
      column: false,
      sortState: '降順',
      sortColumn: 'month',
      sortState2: '降順',
      sortColumn2: 'id',

      id: false,
      student_tutor_id: false,
      student_name: true,
      student_kana: true,
      tutor_name: true,
      tutor_kana: true,
      month: true,
      state: true,
      note: true,
      file_name: true,
      points_english: true,
      points_mathematics: true,
      points_japanese: true,
      points_science: true,
      points_socialstudies: true,
      file: true,
      user: false,
      created_at: true,

      report: {
        student_tutor_id: '',
        month: '',
        state: '',
        filing_date: moment().format('YYYY/MM/DD'), // 表示していない一応投げてる
        note: '',
        file_name: '',
        points_english: '',
        points_mathematics: '',
        points_japanese: '',
        points_science: '',
        points_socialstudies: '',
        file: ''
      },

      watch: {
        file_name: '',
        state: ''
      },

      PatchReport: {
        state: '',
        file_name: '',
        file: ''
      },

      watchPatch: {
        file_name: '',
        state: ''
      },

      search: {
        id: '',
        student_tutor_id: '',
        student_name: '',
        student_kana: '',
        tutor_name: '',
        tutor_kana: '',
        month: '',
        state: '',
        filing_date: '',
        note: '',
        file_name: '',
        points_english: '',
        points_mathematics: '',
        points_japanese: '',
        points_science: '',
        points_socialstudies: '',
        user: '',
        created_at: '',

        not_id: '',
        not_student_tutor_id: '',
        not_student_name: '',
        not_student_kana: '',
        not_tutor_name: '',
        not_tutor_kana: '',
        not_month: '',
        not_state: '',
        not_filing_date: '',
        not_note: '',
        not_file_name: '',
        not_points_english: '',
        not_points_mathematics: '',
        not_points_japanese: '',
        not_points_science: '',
        not_points_socialstudies: '',
        not_user: '',
        not_created_at: ''
      },

      watchSearch: {
        file_name: '',
        state: '',
        not_file_name: '',
        not_state: ''
      },

      search2: {
        id: '',
        family_tel1: '',
        student_name: '',
        student_kana: '',
        tutor_tel1: '',
        tutor_name: '',
        tutor_kana: '',

        not_id: '',
        not_family_tel1: '',
        not_student_name: '',
        not_student_kana: '',
        not_tutor_tel1: '',
        not_tutor_name: '',
        not_tutor_kana: ''
      },

      watchSearch2: {
      },

      fileName: [
        { name: '未選択', value: 0 },
        { name: '指導報告書', value: 1 },
        { name: '引継文章', value: 2 }
      ],

      State: [
        { name: '未選択', value: 0 },
        { name: '提出済', value: 1 },
        { name: '連絡済', value: 2 },
        { name: '未提出', value: 3 },
        { name: 'テキスト未使用', value: 4 }
      ]
    }
  },
  watch: {
    'watch.file_name': function (now, old) {
      // console.log(now)
      if (now) {
        this.report.file_name = now.value
      } else {
        this.report.file_name = ''
      }
    },

    'watchPatch.file_name': function (now, old) {
      // console.log(now)
      if (now) {
        this.PatchReport.file_name = now.value
      } else {
        this.PatchReport.file_name = ''
      }
    },

    'watchSearch.file_name': function (now, old) {
      // console.log(now)
      if (now) {
        this.search.file_name = now.value
      } else {
        this.search.file_name = ''
      }
    },

    'watchSearch.not_file_name': function (now, old) {
      // console.log(now)
      if (now) {
        this.search.not_file_name = now.value
      } else {
        this.search.not_file_name = ''
      }
    },

    'watch.state': function (now, old) {
      // console.log(now)
      if (now) {
        this.report.state = now.value
      } else {
        this.report.state = ''
      }
    },

    'watchPatch.state': function (now, old) {
      // console.log(now)
      if (now) {
        this.PatchReport.state = now.value
      } else {
        this.PatchReport.state = ''
      }
    },

    'watchSearch.state': function (now, old) {
      // console.log(now)
      if (now) {
        this.search.state = now.value
      } else {
        this.search.state = ''
      }
    },

    'watchSearch.not_state': function (now, old) {
      // console.log(now)
      if (now) {
        this.search.not_state = now.value
      } else {
        this.search.not_state = ''
      }
    }
  },
  methods: {
    select (selectedOption, id) {
      // console.log(selectedOption)
    },

    linkReport (list) {
      let URL = config['production'].url
      if (process.env.NODE_ENV === 'development') {
        URL = 'http://localhost:8080'
      }
      let link = URL + '#/report/view/' + list.id
      return link
    },

    switchV (col) {
      this[col] = !this[col]
    },

    reset () {
      this.id = false
      this.student_tutor_id = false
      this.student_name = false
      this.student_kana = false
      this.tutor_name = false
      this.tutor_kana = false
      this.month = false
      this.state = false
      this.note = false
      this.file_name = false
      this.points_english = false
      this.points_mathematics = false
      this.points_japanese = false
      this.points_science = false
      this.points_socialstudies = false
      this.file = false
      this.user = false
      this.created_at = false
    },

    all () {
      this.id = true
      this.student_tutor_id = true
      this.student_name = true
      this.student_kana = true
      this.tutor_name = true
      this.tutor_kana = true
      this.month = true
      this.state = true
      this.note = true
      this.file_name = true
      this.points_english = true
      this.points_mathematics = true
      this.points_japanese = true
      this.points_science = true
      this.points_socialstudies = true
      this.file = true
      this.user = true
      this.created_at = true
    },

    // order By
    sort (header) {
      if (this.sortState === '' || this.sortState === '降順') {
        this.sortState = '昇順'
        this.sortColumn = header
      } else if (this.sortState === '昇順') {
        this.sortState = '降順'
        this.sortColumn = header
      }
    },

    sort2 (header) {
      if (this.sortState2 === '' || this.sortState2 === '降順') {
        this.sortState2 = '昇順'
        this.sortColumn2 = header
      } else if (this.sortState2 === '昇順') {
        this.sortState2 = '降順'
        this.sortColumn2 = header
      }
    },

    offset (e) {
      this.$store.dispatch('SCROLL', {
        this: this,
        e: e,
        obj: obj
      })
    },

    searchTable (e) {
      this.$store.dispatch('SEARCH', {
        this: this,
        e: e,
        obj: obj
      })
    },

    searchTable2 (e) {
      this.$store.dispatch('SEARCH2', {
        this: this,
        e: e,
        obj: obj2
      })
    },

    edit (list) {
      this.edit_id.edit_id = list.id
      this.watchPatch.file_name = this.fileName[list.file_name]
      this.watchPatch.state = this.State[list.state]
    },

    selectedFile (e) {
      e.preventDefault()
      let files = e.target.files
      this.report.file = files[0]
    },

    patchSelectedFile (e) {
      e.preventDefault()
      let files = e.target.files
      this.PatchReport.file = files[0]
    },

    postReport () {
      this.$store.dispatch('postReport', {
        this: this,
        report: this.report
      })
    },

    deleteReport (list) {
      this.$store.dispatch('deleteReport', {
        this: this,
        list: list
      })
    },

    cancelReport (list) {
      this.$store.dispatch('cancelReport', {
        this: this,
        list: list,
        edit_id: this.edit_id
      })
    },

    patchReport (list) {
      this.$store.dispatch('patchReport', {
        this: this,
        list: list,
        edit_id: this.edit_id,
        report: this.PatchReport
      })
    },

    getId (student_tutor) {
      this.report.student_tutor_id = student_tutor.id
    }
  },
  mounted () {
  },
  route: {
  }
}
</script>

<style lang="scss" scoped>
.link {
  text-decoration: none;
  display: table-cell;
  vertical-align: middle;
  border-bottom: solid 1px #ccc;
  border-right: solid 1px #ccc;
  padding: .5rem;
}

.clicked {
  background: #41B883;
  font-weight: bold;
  color: #fff;
}

.index-box {
  height: calc(50vh - 160px);
  overflow: scroll;
  margin-top: 10px;
}

.index-box2 {
  height: calc(50vh - 110px);
  overflow: scroll;
  margin-top: 10px;
}

.upload_form {
  width: 100%;
  .container {
    display: flex;
    .input {
      border: solid 1px #ccc;
      width: 150px;
      height: 36px;
      padding: 10px;
    }
    .points {
      border: solid 1px #ccc;
      width: 100px;
      height: 36px;
      padding: 10px;
    }
    .note {
      height: 36px;
      min-width: 400px;
      border: solid 1px #ccc;
    }
    .box {
      position: relative;
      .fa-camera {
        color: #ccc;
        font-size: 25px;
        padding: 7px;
        height: 36px;
        position: absolute;
        top: 0;
      }
      width: 100%;
      input[type="file"] {
        height: 36px;
        -webkit-appearance: none;
        appearance: none;
        border: solid 1px #ccc;
      }
      input[type="file"]::-webkit-file-upload-button {
        width: 36px;
        height: 36px;
        opacity: 0;
        -webkit-appearance: none;
        appearance: none;
      }
    }
  }
}

.upload {
  border: solid 1px #37474F;
  height: 36px;
  min-width: 120px;
  text-align: center;
  padding-top: 8px;
  cursor: pointer;
  background: #37474F;
  color: #fff;
}

.update_form {
}

.list-edit {
  .td {
    padding: 0 5px 0 5px;
    input {
      height: 23px;
      width: 100%;
    }
    textarea {
      height: 23px;
      width: 100%;
      outline: 0;
      border: none;
    }
  }
}

.m-label-custom {
  z-index: 1;
  cursor: pointer;
  margin-bottom: 1px;
}

.slideActive {
  background: #455A64;
  color: #fff;
}

.active {
  background: #455A64;
  border: solid 1px #455A64;
  color: #fff;
}

.resetSearch {
  padding: 7px 0;
}

.table {
  margin-top: 0 !important;
}

.th, .td {
  padding: 0.5rem 0.5rem;
  border-right: solid 1px #ccc;
  min-width: 60px;
}

.th {
  cursor: pointer;
}

.select {
  padding: 0 !important;
}

input {
  width: 100%;
  min-width: 100px;
  height: 100%;
  padding: 0;
  outline: 0;
  border: none;
}

.del {
  text-align: center;
  cursor: pointer;
  &:hover {
    background: black;
    color: white;
  }
}
</style>

<style lang="scss">
.ReportsIndex {
  .multiselect {
    min-height: 23px;
    min-width: 100px;
  }

  .multiselect__tags {
    border: solid 1px #ccc;
    min-height: 23px;
    padding: 0px 23px 0 2px;
    border-radius: 0;
    border: none;
    // margin: 1px;
  }

  .multiselect__tags-wrap {
    background: red;
  }

  .multiselect__input {
    margin-bottom: 0;
    height: 23px;
  }

  .multiselect__select {
    height: 23px;
    width: 26px;
    top: 2px;
    padding: 0;
    &:before {
      top: 75%;
    }
  }

  .multiselect__single {
    margin-top: 3px;
    margin-bottom: 3px;
  }
}
</style>

<style lang="scss">
.ReportsIndex_upload {
  .multiselect {
    min-height: 34px;
    min-width: 100px;
  }

  .multiselect__tags {
    border: solid 1px #ccc;
    border-radius: 0;
    min-height: 34px;
    padding: 0px 40px 0 2px;
  }

  .multiselect__tags-wrap {
    background: red;
  }

  .multiselect__input {
    margin-bottom: 0;
    height: 34px;
  }

  .multiselect__select {
    height: 34px;
    width: 26px;
    top: 2px;
    padding: 0;
    &:before {
      top: 75%;
    }
  }

  .multiselect__single {
    margin-top: 7px;
    margin-bottom: 7px;
  }
}
</style>



// WEBPACK FOOTER //
// ReportsIndex.vue?3373c488